export function appendAtIfNeeded(text: string): string {
  if (!text || !text.trim().length) return `publicador não encontrado`
  return `${text}`
}

export const PRESS_SOURCE_ID = 2

// Em redes o alcance é estimado a partir dos seguidores do perfil; em imprensa
// a clipadora já manda o alcance da matéria pronto (gravado no mesmo campo),
// então ele é mostrado como veio.
export function getPotentialReach(sourceInternalID: number, followers: number, networkReachFactor: number): number {
  return sourceInternalID === PRESS_SOURCE_ID ? followers : followers * networkReachFactor
}

export function getChannelDisplayText(sourceInternalID: number, channelName: string, approach: string): string {
  return sourceInternalID === 1 ? channelName : approach
}
